module.exports = __webpack_public_path__ + "static/media/books.5a2ba0a6.png";